import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService, Relative } from '../../services/admin.service';

@Component({
  selector: 'app-relative-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './relative-details.component.html',
  styleUrl: './relative-details.component.css'
})
export class RelativeDetailsComponent implements OnInit {
  relative: Relative | null = null;
  isLoading = true;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private adminService: AdminService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      if (id) {
        this.loadRelativeDetails(id);
      } else {
        this.errorMessage = 'Invalid relative ID';
        this.isLoading = false;
      }
    });
  }

  loadRelativeDetails(id: number): void {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.adminService.getRelativeById(id).subscribe({
      next: (response) => {
        this.relative = response.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading relative details:', error);
        this.errorMessage = 'Failed to load relative details';
        this.isLoading = false;
      }
    });
  }

  goBack(): void {
    // Use browser history if available, otherwise navigate to hierarchy
    if (window.history.length > 1) {
      this.location.back();
    } else {
      // Fallback to default navigation - go back to hierarchy
      this.router.navigate(['/hierarchy']);
    }
  }

  goToHierarchy(): void {
    if (this.relative) {
      this.router.navigate(['/hierarchy', this.relative.id]);
    }
  }

  goToTimeline(): void {
    if (this.relative) {
      this.router.navigate(['/relative', this.relative.id, 'timeline']);
    }
  }

  goToFamilyTimeline(): void {
    if (this.relative) {
      this.router.navigate(['/relative', this.relative.id, 'family-timeline']);
    }
  }

  getInitials(relative: Relative): string {
    return `${relative.firstName.charAt(0)}${relative.lastName.charAt(0)}`.toUpperCase();
  }

  calculateAge(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}